// same height
function autoHeight(str, flag = true, val = false) {
  let el_height_list = [];
  $(str).each(function () {
    let el_height = $(this).outerHeight(flag);
    let el_height_1 = $(this).height();
    el_height_list.push(el_height);
    // console.log('eee',str,el_height)
  });
  let max = Math.max.apply(null, el_height_list);
  if (val) {
    return max;
  } else {
    $(str).css("height", `${max}px`);
  }
}

// copy text
function copyText(str) {
  $(str).click(function (e) {
    let that = $(this);
    var text = that.prev().text();
    var input = document.createElement("input");
    input.value = (text + "").trim();
    document.body.appendChild(input);
    input.select();
    document.execCommand("copy");
    document.body.removeChild(input);
    that.addClass("success");
    setTimeout(() => {
      that.removeClass("success");
    }, 1000);
  });
}
// 节流，scroll
function reduceExpend(fn, delay = 500) {
  let startTime = 0;
  return function () {
    let nowTime = new Date().getTime();
    let waitTime = delay - (nowTime - startTime);
    if (waitTime <= 0) {
      startTime = nowTime;
      fn();
    }
  };
}

// is Inviewport
function isViewPort(el) {
  var elementTop = $(el).offset().top;
  var elementBottom = elementTop + $(el).outerHeight() / 2;
  var viewportTop = $(window).scrollTop();
  var viewportHalf = viewportTop + $(window).height() / 2;
  return elementBottom > viewportTop && elementTop < viewportHalf;
}
// resize
function resizeCustomFn(fn) {
  fn();
  $(window).resize(function () {
    fn();
  });
}

// 计算2个视口高度
const DOUBLE_VIEWPORT_HEIGHT = window.innerHeight * 2;

/**
 * 当元素距离视口顶部还有指定高度时触发回调函数
 * 修复了初始状态下元素已在触发区域内但不执行回调的问题
 * @param {string} selector - 要观察的元素选择器
 * @param {Function} callback - 触发时执行的回调函数
 * @param {number} distance - 距离顶部多少像素时触发，默认是2个视口高度
 */
function triggerResizeOnEnterViewport(
  selector,
  callback,
  distance = DOUBLE_VIEWPORT_HEIGHT
) {
  const target = document.querySelector(selector);

  if (!target) {
    console.warn(`找不到选择器为${selector}的元素`);
    return;
  }
  const checkInitialPosition = () => {
    const rect = target.getBoundingClientRect();
    return rect.top <= distance;
  };

  if (checkInitialPosition()) {
    if (typeof callback === "function") {
      callback();
    } else if (window.ScrollTrigger) {
      ScrollTrigger.refresh();
    }
    return;
  }

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (entry.isIntersecting) {
        if (typeof callback === "function") {
          callback();
        } else if (window.ScrollTrigger) {
          ScrollTrigger.refresh();
        }
        observer.disconnect();
      }
    },
    {
      threshold: 0,
      rootMargin: `${distance}px 0px 0px 0px`,
    }
  );

  observer.observe(target);
  return observer;
}

function buyNowProduct(id) {
  $("#upCart").hide();
  var itemsToAdd = [
    {
      id: id,
      quantity: 1,
    },
  ];

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      items: itemsToAdd,
    },
    dataType: "json",
    success: function () {
      window.location.href = "/checkout";
    },
    error: function () {
      $("#upCart").show();
      console.log("加购失败，请重试。");
    },
  });
}
